import { BASE_URL_API } from '../../../References/URLs'

export const fetchPayrollOverview = async ({ token = null, storeIdentifier = null } = {}) => {
    const body = {}

    if (token && storeIdentifier) {
        body.token = token
        body.storeIdentifier = storeIdentifier
    }

    const response = await fetch(BASE_URL_API + 'getPayrollOverview', {
        method: 'POST',
        body: JSON.stringify(body),
    })

    const respo = await response.json()

    if (respo?.status !== 'success') {
        const error = new Error(respo?.message || 'Failed to load payroll overview.')
        error.errorCode = respo?.errorCode || null
        error.response = respo?.response || null
        throw error
    }

    return respo?.response || null
}
